import styled, { breakpoints } from 'src/styles/theme';
import { PriceVatExcludedStyled } from '../PriceVatExcludedStyled';
import { rem } from 'polished';

export const PriceVatExcludedStyledDS = styled(PriceVatExcludedStyled)`
    font-weight: ${({ theme }) => theme.fontWeights.textBold};
    color: ${({ theme }) => theme.colors.grey29};
`;
